import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../../slices/authSlice';
import { Snackbar, Alert } from '@mui/material';
import InvitePeopleDialog from '../../InvitePeopleDialog';
import './people.css';

const ICN = {
    search: (
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
            <circle cx="7" cy="7" r="4.5" stroke="currentColor" strokeWidth="1.6" />
            <path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    ),
    caret: (
        <svg className="caret" viewBox="0 0 10 10" fill="none">
            <path d="M2 4l3 3 3-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    filter: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2 3h10l-4 5v4l-2-1V8L2 3z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    ),
    download: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 2v7m0 0l-3-3m3 3l3-3M2 11v1h10v-1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    vGrid: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <rect x="2" y="2" width="4" height="4" rx="0.8" stroke="currentColor" strokeWidth="1.5" />
            <rect x="8" y="2" width="4" height="4" rx="0.8" stroke="currentColor" strokeWidth="1.5" />
            <rect x="2" y="8" width="4" height="4" rx="0.8" stroke="currentColor" strokeWidth="1.5" />
            <rect x="8" y="8" width="4" height="4" rx="0.8" stroke="currentColor" strokeWidth="1.5" />
        </svg>
    ),
    vTable: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <rect x="2" y="3" width="10" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" />
            <path d="M2 6h10M2 9h10M6 3v8" stroke="currentColor" strokeWidth="1.5" />
        </svg>
    ),
    invite: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="6" cy="5" r="2" stroke="currentColor" strokeWidth="1.5" />
            <path d="M2 12c.6-2 2-3 4-3s3.4 1 4 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M10 3h3M11.5 1.5v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    ),
    more: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <circle cx="3" cy="7" r="1" fill="currentColor" />
            <circle cx="7" cy="7" r="1" fill="currentColor" />
            <circle cx="11" cy="7" r="1" fill="currentColor" />
        </svg>
    ),
    x: (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
    ),
    msg: (
        <svg width="13" height="13" viewBox="0 0 14 14" fill="none">
            <path d="M2 4a1 1 0 011-1h8a1 1 0 011 1v5a1 1 0 01-1 1H6l-3 2v-2H3a1 1 0 01-1-1V4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    ),
    ext: (
        <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
            <path d="M5 2H3a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V7M7 2h3v3M10 2L5 7" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
    star: (
        <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
            <path d="M6 1.5l1.4 2.8 3.1.4-2.3 2.2.6 3.1L6 8.5l-2.8 1.5.6-3.1L1.5 4.7l3.1-.4L6 1.5z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
        </svg>
    ),
    shield: (
        <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
            <path d="M6 1.5L10.5 3v3.5c0 2.4-2 4-4.5 4.5C3.5 10.5 1.5 8.9 1.5 6.5V3L6 1.5z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
        </svg>
    ),
    clock: (
        <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
            <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.3" />
            <path d="M6 3.5V6l1.5 1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        </svg>
    ),
    check: (
        <svg width="11" height="11" viewBox="0 0 12 12" fill="none">
            <path d="M2 6l2.5 2.5L10 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    ),
};

const VIEWS = ['Everyone', 'Members', 'Translators', 'Reviewers', 'Pending invites', 'Suspended'];

const ROLES = ['Any role', 'Admin', 'Localization PM', 'Engineer', 'Translator', 'Reviewer', 'Designer', 'Viewer'];
const LANGS = ['Any language', 'EN', 'DE', 'FR', 'JA', 'ES', 'PT', 'IT', 'ZH', 'KO', 'AR', 'SV', 'NO', 'PL', 'PT-BR'];
const TEAMS = ['Any team', 'Marketing', 'Brand', 'Product', 'Engineering', 'Lifecycle', 'Support', 'Operations'];
const STATES = ['Any state', 'Online', 'Away', 'Offline', 'Invited'];

const FACET_CYCLES = { role: ROLES, lang: LANGS, team: TEAMS, state: STATES };
const FACET_DEFAULTS = { role: 'Any role', lang: 'Any language', team: 'Any team', state: 'Any state' };

const initials = (name) => (name || '?')
    .split(' ')
    .map((p) => p[0])
    .filter(Boolean)
    .join('')
    .slice(0, 2)
    .toUpperCase();

const avPal = (idx) => `av-${(idx % 6) + 1}`;

const langCode = (l) => (typeof l === 'string' ? l : (l && (l.code || l.name)) || '').toUpperCase();

const normalizeMembers = (raw) => raw.map((m, i) => {
    const u = m.userId || m.user || m;
    const fullName = `${u.firstName || ''} ${u.lastName || ''}`.trim();
    const isInvite = m.invitationStatus === 'pending';
    const status = isInvite
        ? 'invite'
        : (m.status || (m.online ? 'online' : 'offline'));
    const role = m.role || (u.translatedLanguages ? 'Translator' : 'Member');
    const kind = isInvite
        ? 'invite'
        : (role && /admin|pm|engineer|designer/i.test(role) ? 'member' : 'external');
    const langs = (u.translatedLanguages || m.languages || []).map(langCode).filter(Boolean);
    return {
        id: u._id || m._id || `m-${i}`,
        name: isInvite ? (u.email || fullName || `Invite ${i + 1}`) : (fullName || u.email || `Member ${i + 1}`),
        email: u.email,
        initials: initials(fullName || u.email),
        av: avPal(i),
        role,
        kind,
        langs,
        teams: m.teams || [],
        workload: Math.max(0, Math.min(100, Math.round(u.workloadCapacity || m.workload || 0))),
        projects: m.assignedProjectsCount || 0,
        status,
        last: m.lastActive
            ? `Active ${new Date(m.lastActive).toLocaleString()}`
            : (isInvite ? `Invited ${m.invitedAt ? new Date(m.invitedAt).toLocaleDateString() : 'recently'}` : 'Offline'),
        joined: u.createdAt ? new Date(u.createdAt).toLocaleDateString(undefined, { month: 'short', year: 'numeric' }) : '',
        invitedBy: (m.invitedBy && (m.invitedBy.name || m.invitedBy.email)) || 'Admin',
        rate: u.rate || '',
        quality: u.performanceStats && u.performanceStats.qualityScore,
        perms: m.role || 'Member',
        flag: (u.workloadCapacity || m.workload || 0) > 90 ? 'overcap' : null,
        you: !!m.isYou,
    };
});

const StatusDot = ({ status }) => <span className={`pp-status-dot s-${status}`} title={status} />;

const RoleTag = ({ role }) => {
    const tone =
        role === 'Admin' || role === 'Localization PM' ? 'tone-indigo' :
        role === 'Engineer' ? 'tone-green' :
        /translator/i.test(role) ? 'tone-accent' :
        /reviewer/i.test(role) ? 'tone-yellow' :
        role === 'Designer' ? 'tone-purple' : 'tone-quiet';
    return <span className={`pp-role-tag ${tone}`}>{role}</span>;
};

const Workload = ({ pct, flag }) => {
    const tone = flag === 'overcap' ? 'wl-warn' : pct > 75 ? 'wl-busy' : pct > 40 ? 'wl-ok' : 'wl-light';
    return (
        <div className="pp-workload">
            <div className="pp-wl-row">
                <span className="pp-wl-lbl">Workload</span>
                <span className={`pp-wl-val ${tone}`}>
                    {pct}%{flag === 'overcap' && <span className="pp-overcap-tag">over cap</span>}
                </span>
            </div>
            <div className="pp-wl-bar">
                <span className={`pp-wl-fill ${tone}`} style={{ width: pct + '%' }} />
            </div>
        </div>
    );
};

const Stats = ({ members, limits }) => {
    // Seat numbers come from /api/team/limits — same source as TeamPage —
    // so the People page and the team-management page can't disagree.
    // Fall back to deriving from the loaded members list if limits is
    // unavailable (offline, 500, etc.) so we still render something.
    const fullSeats = limits?.fullSeats ?? members.filter(
        (m) => /manager|lead/i.test(m.role) && m.kind !== 'invite',
    ).length;
    const fullLimit = limits?.fullSeatLimit ?? 0;
    const fullUnlimited = !!limits?.fullSeatLimitIsUnlimited;
    const linguistSeats = limits?.linguistSeats ?? members.filter(
        (m) => /translator|proofreader|editor|reviewer|qa/i.test(m.role) && m.kind !== 'invite',
    ).length;
    const linguistLimit = limits?.linguistSeatLimit ?? 0;
    const linguistUnlimited = !!limits?.linguistSeatLimitIsUnlimited;
    const planLabel = limits?.planLabel || 'plan';

    // Sub-line on the linguist tile breaks down by role + idle count.
    const linguistRows = members.filter(
        (m) => /translator|proofreader|editor|reviewer|qa/i.test(m.role) && m.kind !== 'invite',
    );
    const translatorCount = linguistRows.filter((m) => /translator/i.test(m.role)).length;
    const reviewerCount = linguistRows.filter((m) => /reviewer|proofreader/i.test(m.role)).length;
    const idleLinguists = linguistRows.filter((m) => m.workload < 10).length;

    const langSet = new Set();
    members.forEach((m) => m.langs.forEach((l) => langSet.add(l)));
    const langList = Array.from(langSet);

    const liveLoad = members.filter((m) => m.kind !== 'invite');
    const avgLoad = liveLoad.length
        ? Math.round(liveLoad.reduce((s, m) => s + m.workload, 0) / liveLoad.length)
        : 0;
    const overCap = members.filter((m) => m.flag === 'overcap').length;
    const idleAll = liveLoad.filter((m) => m.workload < 10).length;

    const fullPct = fullUnlimited || fullLimit === 0
        ? Math.min(100, fullSeats * 20) // visual hint when limit is 0/∞
        : Math.min(100, (fullSeats / fullLimit) * 100);

    return (
        <div className="pp-stats">
            <div className="pp-stat">
                <div className="pp-stat-lbl">Manager seats</div>
                <div className="pp-stat-val">
                    {fullSeats}
                    <span className="pp-stat-unit">/ {fullUnlimited ? '∞' : fullLimit} seats</span>
                </div>
                <div className="pp-stat-bar">
                    <span style={{ width: fullPct + '%' }} />
                </div>
                <div className="pp-stat-sub">{planLabel}</div>
            </div>
            <div className="pp-stat">
                <div className="pp-stat-lbl">Linguist seats</div>
                <div className="pp-stat-val">
                    {linguistSeats}
                    <span className="pp-stat-unit">/ {linguistUnlimited ? '∞' : linguistLimit} seats</span>
                </div>
                <div className="pp-stat-sub">
                    {translatorCount} translator{translatorCount === 1 ? '' : 's'} ·{' '}
                    {reviewerCount} reviewer{reviewerCount === 1 ? '' : 's'} ·{' '}
                    {idleLinguists} idle this week
                </div>
            </div>
            <div className="pp-stat">
                <div className="pp-stat-lbl">Languages covered</div>
                <div className="pp-stat-val">{langList.length}</div>
                <div className="pp-stat-sub">{langList.slice(0, 14).join(', ') || '—'}</div>
            </div>
            <div className="pp-stat">
                <div className="pp-stat-lbl">Capacity used</div>
                <div className="pp-stat-val">{avgLoad}<span className="pp-stat-unit">%</span></div>
                <div className="pp-stat-sub">
                    {overCap > 0 && <span className="pp-stat-warn">{overCap} over cap</span>}
                    {overCap > 0 && ' · '}{idleAll} idle · avg {avgLoad}%
                </div>
            </div>
        </div>
    );
};

const InvitesStrip = ({ invites }) => {
    if (invites.length === 0) return null;
    return (
        <div className="pp-invites-strip">
            <div className="pp-invites-h">
                <span className="pp-invites-dot" />
                <b>{invites.length} pending {invites.length === 1 ? 'invite' : 'invites'}</b>
                <span className="pp-invites-sub">awaiting acceptance.</span>
                <div style={{ marginLeft: 'auto' }}>
                    <button type="button" className="pp-mini-btn">Resend all</button>
                </div>
            </div>
            <div className="pp-invites-list">
                {invites.map((p) => (
                    <div className="pp-invite" key={p.id}>
                        <div className={`pp-av ${p.av}`}>{p.initials}</div>
                        <div className="pp-invite-body">
                            <div className="pp-invite-email">{p.name}</div>
                            <div className="pp-invite-meta">
                                {p.role} · {p.langs.join('·')} · <span style={{ color: 'var(--ink-4)' }}>{p.last} by {p.invitedBy}</span>
                            </div>
                        </div>
                        <div className="pp-invite-actions">
                            <button type="button" className="pp-mini-btn">Resend</button>
                            <button type="button" className="pp-mini-btn quiet">Revoke</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

const Views = ({ active, setActive, counts }) => (
    <div className="rs-views">
        {VIEWS.map((name) => (
            <button
                key={name}
                type="button"
                className={`rs-view-tab ${active === name ? 'on' : ''}`}
                onClick={() => setActive(name)}
            >
                {name}
                <span className="ct">{counts[name] || 0}</span>
            </button>
        ))}
        <button type="button" className="rs-view-tab add">+ Save view</button>
    </div>
);

const Toolbar = ({ q, setQ, view, setView, facets, cycleFacet, clearFacets }) => {
    const defs = [
        ['role', 'Role', 'Any role'],
        ['lang', 'Language', 'Any language'],
        ['team', 'Team', 'Any team'],
        ['state', 'State', 'Any state'],
    ];
    const anyApplied = defs.some(([k, , def]) => facets[k] !== def);
    return (
        <div className="rs-toolbar">
            <div className="rs-tb-search">
                {ICN.search}
                <input
                    placeholder="Search people, emails, languages…"
                    value={q}
                    onChange={(e) => setQ(e.target.value)}
                />
                <span className="kbd">/</span>
            </div>
            {defs.map(([k, label, def]) => {
                const v = facets[k] || def;
                const applied = v !== def;
                return (
                    <button
                        key={k}
                        type="button"
                        className={`rs-tb-facet ${applied ? 'applied' : ''}`}
                        onClick={() => cycleFacet(k)}
                    >
                        <span className="lbl-k">{label}:</span>
                        <span className="lbl-v">{v}</span>
                        {ICN.caret}
                    </button>
                );
            })}
            {anyApplied && (
                <button type="button" className="rs-tb-facet" onClick={clearFacets} style={{ color: 'var(--ink-3)' }}>
                    {ICN.x}<span style={{ fontWeight: 500 }}>Clear</span>
                </button>
            )}
            <div className="rs-tb-spacer" />
            <div className="rs-tb-view" role="tablist" aria-label="View">
                <button type="button" className={view === 'grid' ? 'on' : ''} onClick={() => setView('grid')} aria-label="Grid view">{ICN.vGrid}</button>
                <button type="button" className={view === 'table' ? 'on' : ''} onClick={() => setView('table')} aria-label="Table view">{ICN.vTable}</button>
            </div>
        </div>
    );
};

const PersonCard = ({ p, selected, toggle }) => {
    const isInvite = p.kind === 'invite';
    return (
        <article className={`pp-card ${selected ? 'is-sel' : ''} ${isInvite ? 'is-invite' : ''}`}>
            <label className="pp-sel">
                <input type="checkbox" checked={!!selected} onChange={() => toggle(p.id)} />
                <span className="pp-sel-box">{ICN.check}</span>
            </label>

            <div className="pp-card-top">
                <div className={`pp-av pp-av-lg ${p.av}`}>
                    {p.initials}
                    {!isInvite && <StatusDot status={p.status} />}
                </div>
                <div className="pp-card-id">
                    <div className="pp-name-row">
                        <h4>{p.name}</h4>
                        {p.you && <span className="pp-you">You</span>}
                        {p.perms === 'Owner' && <span className="pp-perm-tag" title="Workspace owner">{ICN.star}</span>}
                        {p.perms === 'Admin' && !p.you && <span className="pp-perm-tag" title="Workspace admin">{ICN.shield}</span>}
                    </div>
                    {!isInvite && p.email && <div className="pp-card-email">{p.email}</div>}
                    <div className="pp-card-meta">
                        <RoleTag role={p.role} />
                        {p.kind === 'external' && <span className="pp-ext-tag">{ICN.ext} External</span>}
                        {isInvite && <span className="pp-ext-tag pp-invite-tag">{ICN.clock} Invite</span>}
                    </div>
                </div>
                <button type="button" className="pp-more" aria-label="More">{ICN.more}</button>
            </div>

            {p.langs.length > 0 && (
                <div className="pp-langs">
                    {p.langs.map((l) => <span className="pp-lang" key={l}>{l}</span>)}
                </div>
            )}

            {!isInvite && <Workload pct={p.workload} flag={p.flag} />}
            {isInvite && (
                <div className="pp-invite-body-inline">
                    {p.last} by <b>{p.invitedBy}</b>.
                </div>
            )}

            <div className="pp-card-foot">
                {!isInvite ? (
                    <>
                        <div className="pp-foot-stat">
                            <span className="n">{p.projects}</span>
                            <span className="l">project{p.projects === 1 ? '' : 's'}</span>
                        </div>
                        <div className="pp-foot-stat">
                            <span className="n">{p.teams.length}</span>
                            <span className="l">team{p.teams.length === 1 ? '' : 's'}</span>
                        </div>
                        {p.kind === 'external' && p.quality != null && (
                            <div className="pp-foot-stat">
                                <span className="n">{Number(p.quality).toFixed(1)}<span style={{ fontSize: 11, color: 'var(--ink-3)' }}>%</span></span>
                                <span className="l">quality</span>
                            </div>
                        )}
                        <div className="pp-foot-actions">
                            <button type="button" className="pp-icon-btn" title="Message">{ICN.msg}</button>
                            <button type="button" className="pp-mini-btn">Assign</button>
                        </div>
                    </>
                ) : (
                    <>
                        <button type="button" className="pp-mini-btn">Resend invite</button>
                        <button type="button" className="pp-mini-btn quiet">Revoke</button>
                    </>
                )}
            </div>

            {!isInvite && (
                <div className="pp-last-seen">
                    <span className={`pp-last-dot s-${p.status}`} />
                    {p.last}
                </div>
            )}
        </article>
    );
};

const PersonTable = ({ rows, selected, toggleSel, toggleAll }) => {
    const allOn = rows.length > 0 && rows.every((r) => selected[r.id]);
    return (
        <div className="rs-card flat pp-table-card">
            <div className="pp-tbl-row head">
                <label className="pp-sel pp-sel-row">
                    <input type="checkbox" checked={allOn} onChange={toggleAll} />
                    <span className="pp-sel-box">{ICN.check}</span>
                </label>
                <span>Name</span>
                <span>Role</span>
                <span>Languages</span>
                <span>Teams</span>
                <span>Workload</span>
                <span>Projects</span>
                <span>Last active</span>
                <span />
            </div>
            {rows.map((p) => {
                const isInvite = p.kind === 'invite';
                return (
                    <div className={`pp-tbl-row body ${selected[p.id] ? 'is-sel' : ''}`} key={p.id}>
                        <label className="pp-sel pp-sel-row" onClick={(e) => e.stopPropagation()}>
                            <input type="checkbox" checked={!!selected[p.id]} onChange={() => toggleSel(p.id)} />
                            <span className="pp-sel-box">{ICN.check}</span>
                        </label>

                        <div className="pp-tbl-name">
                            <div className={`pp-av ${p.av}`}>
                                {p.initials}
                                {!isInvite && <StatusDot status={p.status} />}
                            </div>
                            <div className="pp-tbl-name-body">
                                <div className="pp-tbl-nm-row">
                                    <b>{p.name}</b>
                                    {p.you && <span className="pp-you">You</span>}
                                    {p.kind === 'external' && <span className="pp-ext-tag">{ICN.ext} External</span>}
                                    {isInvite && <span className="pp-ext-tag pp-invite-tag">{ICN.clock} Invite</span>}
                                </div>
                                {!isInvite && p.email && <span className="pp-tbl-nm-sub">{p.email}</span>}
                                {isInvite && <span className="pp-tbl-nm-sub">{p.last} by {p.invitedBy}</span>}
                            </div>
                        </div>

                        <div><RoleTag role={p.role} /></div>

                        <div className="pp-tbl-langs">
                            {p.langs.slice(0, 3).map((l) => <span className="pp-lang" key={l}>{l}</span>)}
                            {p.langs.length > 3 && <span className="pp-lang more">+{p.langs.length - 3}</span>}
                        </div>

                        <div className="pp-tbl-teams">
                            {p.teams.slice(0, 2).map((t) => <span className="pp-team-chip" key={t}>{t}</span>)}
                            {p.teams.length > 2 && <span className="pp-team-chip more">+{p.teams.length - 2}</span>}
                        </div>

                        <div className="pp-tbl-wl">
                            {!isInvite ? (
                                <div className="pp-tbl-wl-inner">
                                    <div className="pp-wl-bar">
                                        <span
                                            className={`pp-wl-fill ${p.flag === 'overcap' ? 'wl-warn' : p.workload > 75 ? 'wl-busy' : p.workload > 40 ? 'wl-ok' : 'wl-light'}`}
                                            style={{ width: p.workload + '%' }}
                                        />
                                    </div>
                                    <span className="pp-wl-num">{p.workload}%</span>
                                </div>
                            ) : <span className="pp-tbl-empty">—</span>}
                        </div>

                        <div className="pp-tbl-projects">
                            {!isInvite ? <span className="pp-projects-num">{p.projects}</span> : <span className="pp-tbl-empty">—</span>}
                        </div>

                        <div className="pp-tbl-last">{p.last}</div>

                        <button type="button" className="pp-more" aria-label="More">{ICN.more}</button>
                    </div>
                );
            })}
        </div>
    );
};

const BulkBar = ({ count, clear }) => (
    <div className="pp-bulk">
        <span className="pp-bulk-count">{count} selected</span>
        <div className="pp-bulk-spacer" />
        <button type="button" className="pp-bulk-btn">Assign to project</button>
        <button type="button" className="pp-bulk-btn">Add to team</button>
        <button type="button" className="pp-bulk-btn">Change role</button>
        <button type="button" className="pp-bulk-btn quiet">Suspend</button>
        <button type="button" className="pp-bulk-btn quiet" onClick={clear}>Clear</button>
    </div>
);

const People = () => {
    const token = useSelector((s) => s.auth.token);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [members, setMembers] = useState([]);
    const [limits, setLimits] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeView, setActiveView] = useState('Everyone');
    const [q, setQ] = useState('');
    const [view, setView] = useState('grid');
    const [facets, setFacets] = useState({ ...FACET_DEFAULTS });
    const [selected, setSelected] = useState({});
    const [inviteOpen, setInviteOpen] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    const refreshTeam = React.useCallback(() => {
        if (!token) return;
        const headers = { Authorization: `Bearer ${token}` };
        Promise.all([
            axios.get('/api/team', { headers }),
            axios.get('/api/team/limits', { headers }).catch(() => ({ data: null })),
        ]).then(([teamRes, limitsRes]) => {
            setMembers(normalizeMembers(Array.isArray(teamRes.data) ? teamRes.data : []));
            setLimits(limitsRes.data || null);
        }).catch(() => { /* non-fatal */ });
    }, [token]);

    useEffect(() => {
        if (!token) return;
        const headers = { Authorization: `Bearer ${token}` };
        Promise.all([
            axios.get('/api/team', { headers }),
            // Limits is opportunistic — if it fails we still render the page
            // with members; the stats tile just falls back to derived counts.
            axios.get('/api/team/limits', { headers }).catch(() => ({ data: null })),
        ])
            .then(([teamRes, limitsRes]) => {
                setMembers(normalizeMembers(Array.isArray(teamRes.data) ? teamRes.data : []));
                setLimits(limitsRes.data || null);
                setLoading(false);
            })
            .catch((err) => {
                if (err.response && err.response.status === 401) {
                    dispatch(logout());
                    navigate('/login');
                } else {
                    setError('Failed to load team.');
                    setLoading(false);
                }
            });
    }, [token, dispatch, navigate]);

    const cycleFacet = (k) => setFacets((f) => {
        const cyc = FACET_CYCLES[k];
        const i = cyc.indexOf(f[k] || cyc[0]);
        return { ...f, [k]: cyc[(i + 1) % cyc.length] };
    });
    const clearFacets = () => setFacets({ ...FACET_DEFAULTS });

    const counts = useMemo(() => ({
        Everyone: members.length,
        Members: members.filter((m) => m.kind === 'member').length,
        Translators: members.filter((m) => /translator/i.test(m.role)).length,
        Reviewers: members.filter((m) => /reviewer/i.test(m.role)).length,
        'Pending invites': members.filter((m) => m.kind === 'invite').length,
        Suspended: members.filter((m) => m.status === 'suspended').length,
    }), [members]);

    const rows = useMemo(() => {
        let r = members;
        if (activeView === 'Members') r = r.filter((p) => p.kind === 'member');
        else if (activeView === 'Translators') r = r.filter((p) => /translator/i.test(p.role));
        else if (activeView === 'Reviewers') r = r.filter((p) => /reviewer/i.test(p.role));
        else if (activeView === 'Pending invites') r = r.filter((p) => p.kind === 'invite');
        else if (activeView === 'Suspended') r = r.filter((p) => p.status === 'suspended');

        const s = q.trim().toLowerCase();
        if (s) {
            r = r.filter((p) =>
                (`${p.name} ${p.email || ''} ${p.role} ${p.langs.join(' ')} ${p.teams.join(' ')}`)
                    .toLowerCase()
                    .includes(s),
            );
        }
        if (facets.role !== FACET_DEFAULTS.role) r = r.filter((p) => p.role === facets.role);
        if (facets.lang !== FACET_DEFAULTS.lang) r = r.filter((p) => p.langs.includes(facets.lang));
        if (facets.team !== FACET_DEFAULTS.team) r = r.filter((p) => p.teams.includes(facets.team));
        if (facets.state !== FACET_DEFAULTS.state) {
            const map = { Online: 'online', Away: 'away', Offline: 'offline', Invited: 'invite' };
            r = r.filter((p) => p.status === map[facets.state]);
        }
        return r;
    }, [members, activeView, q, facets]);

    const invites = useMemo(() => members.filter((p) => p.kind === 'invite'), [members]);

    const toggleSel = (id) => setSelected((s) => ({ ...s, [id]: !s[id] }));
    const toggleAll = () => {
        const allOn = rows.length > 0 && rows.every((r) => selected[r.id]);
        const next = { ...selected };
        rows.forEach((r) => { next[r.id] = !allOn; });
        setSelected(next);
    };
    const clearSel = () => setSelected({});
    const selCount = Object.values(selected).filter(Boolean).length;

    const showInviteStrip =
        activeView === 'Everyone' && !q.trim() &&
        facets.role === FACET_DEFAULTS.role && facets.state === FACET_DEFAULTS.state;

    if (loading) return <div style={{ padding: 40, color: 'var(--ink-3)' }}>Loading team…</div>;
    if (error) return <div style={{ padding: 40, color: 'crimson' }}>{error}</div>;

    return (
        <>
            <div className="rs-page-title-row">
                <h1 className="rs-page-title">People</h1>
                <span className="rs-page-title-count">{members.length}</span>
                <div className="rs-page-actions">
                    <button type="button" className="btn-q">{ICN.download}<span>Export</span></button>
                    <button type="button" className="btn-q">{ICN.filter}<span>Filters</span></button>
                    <button type="button" className="btn-p" onClick={() => setInviteOpen(true)}>
                        {ICN.invite}<span>Invite people</span>
                    </button>
                </div>
            </div>
            <p className="rs-page-sub">
                Members, reviewers, and external linguists across your workspace. Manage roles, language coverage, and who's at capacity.
            </p>

            <Stats members={members} limits={limits} />

            {showInviteStrip && <InvitesStrip invites={invites} />}

            <Views active={activeView} setActive={setActiveView} counts={counts} />

            <Toolbar
                q={q} setQ={setQ}
                view={view} setView={setView}
                facets={facets}
                cycleFacet={cycleFacet}
                clearFacets={clearFacets}
            />

            {rows.length === 0 ? (
                <div
                    className="rs-card"
                    style={{ padding: 64, textAlign: 'center', border: '1.5px dashed var(--line-2)', background: 'transparent' }}
                >
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" style={{ margin: '0 auto 10px', display: 'block', color: 'var(--ink-4)' }}>
                        <circle cx="13" cy="12" r="4.5" stroke="currentColor" strokeWidth="1.5" />
                        <path d="M5 26c1-4.5 4.2-7 8-7s7 2.5 8 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                        <path d="M22 9h6M25 6v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                    <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>No people here yet</div>
                    <div style={{ fontSize: 13, color: 'var(--ink-3)' }}>
                        Try a different view, clear filters, or invite someone new.
                    </div>
                </div>
            ) : view === 'grid' ? (
                <div className="pp-grid">
                    {rows.map((p) => (
                        <PersonCard key={p.id} p={p} selected={selected[p.id]} toggle={toggleSel} />
                    ))}
                </div>
            ) : (
                <PersonTable rows={rows} selected={selected} toggleSel={toggleSel} toggleAll={toggleAll} />
            )}

            {selCount > 0 && <BulkBar count={selCount} clear={clearSel} />}

            <InvitePeopleDialog
                open={inviteOpen}
                onClose={() => setInviteOpen(false)}
                token={token}
                teamLimits={limits}
                onSent={() => refreshTeam()}
                onSnackbar={(s) => setSnackbar(s)}
            />

            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar((p) => ({ ...p, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    severity={snackbar.severity}
                    onClose={() => setSnackbar((p) => ({ ...p, open: false }))}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default People;
